
import { defineComponent } from 'vue';
import NImageViewer from '@/uikit/image-viewer/NImageViewer.vue';

export default defineComponent({
  name: 'ImageViewer',
  components: { NImageViewer }
});
